import React, { useEffect, useState } from 'react'
import { FormCustom, Input, SwitchToggle, TextArea } from '../../../components/form'
import ReactPlaceholder from 'react-placeholder/lib'
import { useGetId, useSaveUpdate } from '../../../hooks/process-data'
import { useMemo } from 'react'
import { apiResource, doToast } from '../../../utils'
import { doRequestGet } from '../../../api'
import SelectCustom from '../../../components/select-custom/SelectCustom'
import { toast } from 'react-toastify'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const EventForm = ({ rowId, setReload }) => {
  const [row, setRow] = useState({
    p_id_event: '',
    p_name_event: '',
    p_date_event: '',
    p_hour_event: '',
    p_location_event: '',
    p_image_event: [],
    p_image_event_path: '',
    p_banner_small_event: [],
    p_banner_small_event_path: '',
    p_banner_large_event: [],
    p_banner_large_event_path: '',
    p_slug_event: '',
    p_id_type_event: '',
    p_enabled_event: 0,
    p_pdf_background: [],
    p_pdf_background_path: '',
    p_pdf_background_pos: [],
    p_pdf_background_pos_path: '',
    p_show_ecommerce: 0,
    p_banner_tablet_event: [],             // tablet file
    p_banner_tablet_event_path: '',        // tablet path
    p_banner_mobile_event: [],             // mobile file
    p_banner_mobile_event_path: '',        // mobile path
    p_seo_title: '',
    p_seo_description: '',
    p_seo_keywords: '',
    p_presale_date_event: '',
    p_subtitle_event: '',
  })
  const [ready, setReady] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [previewBannerSmall, setPreviewBannerSmall] = useState(null)
  const [previewBannerDesktop, setPreviewBannerDesktop] = useState(null)
  const [previewBannerTablet, setPreviewBannerTablet] = useState(null)
  const [previewBannerMobile, setPreviewBannerMobile] = useState(null)
  const [previewBg, setPreviewBg] = useState(null)
  const [previewBgPos, setPreviewBgPos] = useState(null)
  const [typeEvents, setTypeEvents] = useState([])

  const [content, setContent] = useState('')

  const modules = {
    toolbar: [
      [{ font: [] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ script: "sub" }, { script: "super" }],
      ["blockquote", "code-block"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }, { align: [] }],
      ["link", "image", "video"],
      ["clean"],
    ]
  }

  const dataSubmit = useMemo(() => {
    let formData = new FormData();

    for (const key in row) {
      if (key === 'p_image_event' || key === 'p_banner_small_event' || key === 'p_banner_large_event' || key === 'p_pdf_background' || key === 'p_pdf_background_pos' || key === 'p_banner_tablet_event' || key === 'p_banner_mobile_event') {
        if (row[key].length > 0) {
          formData.append(key, row[key][0]);
        }
      } else {
        formData.append(key, row[key]);
      }
    }

    formData.append('p_description_event', content);

    return formData;
  }, [row, content])

  const { doSubmit, setDoSubmit } = useSaveUpdate({
    data: dataSubmit,
    url: '/event',
    hasFile: true,
    setReload
  })

  const { isProcessing, getRow, error } = useGetId({
    url: '/event/' + rowId,
    rowId: rowId
  })

  useEffect(() => {
    const getData = async function () {
      if (error) {
        setReload();
      } else {
        if (!isProcessing && !ready) {
          const getTypesEvents = await doRequestGet({
            url: '/type-event'
          })
          setTypeEvents(getTypesEvents.data);

          if (rowId) {
            setRow({
              p_id_event: getRow.id_event,
              p_name_event: getRow.name_event,
              p_date_event: getRow.date_event,
              p_hour_event: getRow.hour_event,
              p_location_event: getRow.location_event,
              p_image_event: [],
              p_image_event_path: getRow.image_event,
              p_banner_small_event: [],
              p_banner_small_event_path: getRow.banner_small_event,
              p_banner_large_event: [],
              p_banner_large_event_path: getRow.banner_large_event,
              p_id_type_event: getRow.id_type_event,
              p_slug_event: getRow.slug_event,
              p_enabled_event: getRow.enabled_event,
              p_pdf_background: [],
              p_pdf_background_path: getRow.pdf_background,
              p_pdf_background_pos: [],
              p_pdf_background_pos_path: getRow.pdf_background_pos || '',
              p_show_ecommerce: getRow.show_ecommerce,
              p_banner_tablet_event: [],
              p_banner_tablet_event_path: getRow.banner_tablet_event || '',
              p_banner_mobile_event: [],
              p_banner_mobile_event_path: getRow.banner_mobile_event || '',
              p_seo_title: getRow.seo_title || '',
              p_seo_description: getRow.seo_description || '',
              p_seo_keywords: getRow.seo_keywords || '',
              p_presale_date_event: getRow.presale_date_event || '',
              p_subtitle_event: getRow.subtitle_event || '',
            })

            setContent(getRow.description_event)
          }
          setReady(true);
        }
      }
    }

    getData();
  }, [isProcessing, getRow, error, setReload, rowId, ready, content])

  return <ReactPlaceholder ready={ready} rows={5}>
    <FormCustom onSubmit={() => {
      if (!row.p_id_type_event) {
        doToast({
          response: 'warning',
          message: 'Debe seleccionar un tipo de evento',
          toast
        })
        return
      }

      // validate if the slug onle has letters and numbers and -
      if (!/^[a-zA-Z0-9-]*$/.test(row.p_slug_event)) {
        doToast({
          response: 'warning',
          message: 'El slug solo debe contener letras, números y guiones medios',
          toast
        })
        return
      }

      setDoSubmit(true)
    }} loadSubmit={doSubmit}>
      <Input
        text="Nombre"
        placeholder="Nombre"
        classNameParent="col-12 mb-3"
        required
        invalid="El campo es obligatorio."
        value={row.p_name_event}
        onChange={e => {
          setRow({
            ...row,
            p_name_event: e.target.value,
            p_slug_event: e.target.value.replace(/[^\w\s]/gi, '').toLowerCase().replace(/ /g, '-')
          })
        }}
        maxLength={255}
      />
      <Input
        text="Subtítulo"
        placeholder="Subtítulo"
        classNameParent="col-12 mb-3"
        value={row.p_subtitle_event}
        onChange={e => setRow({ ...row, p_subtitle_event: e.target.value })}
        maxLength={255}
        required
      />
      <Input
        text="Fecha de preventa"
        type="date"
        placeholder="Fecha de preventa"
        classNameParent="col-12 mb-3"
        value={row.p_presale_date_event}
        onChange={e => setRow({ ...row, p_presale_date_event: e.target.value })}
        required
      />
      <Input
        text="Slug"
        placeholder="Slug"
        classNameParent="col-12 mb-3"
        required
        invalid="El campo es obligatorio."
        value={row.p_slug_event}
        onChange={e => setRow({ ...row, p_slug_event: e.target.value })}
        maxLength={255}
      />
      <SwitchToggle
        id="event-enabled"
        textCheck="Desactivar"
        textUnChecked="Activar"
        classNameParent="col-12 mb-3"
        checked={row.p_enabled_event === 1}
        onChange={e => setRow({ ...row, p_enabled_event: e.target.checked ? 1 : 0 })}
      />
      <SwitchToggle
        id="event-show-ecommerce"
        textCheck="Desactivar Ecommerce"
        textUnChecked="Activar Ecommerce"
        classNameParent="col-12 mb-3"
        checked={row.p_show_ecommerce === 1}
        onChange={e => setRow({ ...row, p_show_ecommerce: e.target.checked ? 1 : 0 })}
      />
      <SelectCustom
        valueId={row.p_id_type_event}
        keyName="type_event"
        options={typeEvents}
        setRow={setRow}
        row={row}
        selectText="Tipo de evento"
      />
      <Input
        text="Fecha"
        type="date"
        placeholder="Fecha"
        classNameParent="col-12 mb-3"
        required
        invalid="El campo es obligatorio."
        value={row.p_date_event}
        onChange={e => setRow({ ...row, p_date_event: e.target.value })}
      />
      <Input
        text="Hora"
        type="time"
        placeholder="Hora"
        classNameParent="col-12 mb-3"
        required
        invalid="El campo es obligatorio."
        value={row.p_hour_event}
        onChange={e => setRow({ ...row, p_hour_event: e.target.value })}
        step="1"
      />
      <Input
        text="Ubicación"
        placeholder="Ubicación"
        classNameParent="col-12 mb-3"
        required
        invalid="El campo es obligatorio."
        value={row.p_location_event}
        onChange={e => setRow({ ...row, p_location_event: e.target.value })}
        maxLength={255}
      />
      <div className="col-12 mb-4">
        <small>Descripción</small>
        <ReactQuill theme="snow" value={content} onChange={setContent} modules={modules} />
      </div>

      <div className="col-12 mb-3">
        <div className="d-flex align-items-center justify-content-between mb-2 flex-wrap gap-2">
          <div>
            <h5 className="mb-0">SEO</h5>
            <small className="text-muted">
              SEO para el evento.
            </small>
          </div>
        </div>
        <Input
          text="Título SEO"
          placeholder="Título SEO"
          classNameParent="col-12 mb-3"
          value={row.p_seo_title}
          onChange={e => setRow({ ...row, p_seo_title: e.target.value })}
          required
        />
        <TextArea
          text="Descripción SEO"
          placeholder="Descripción SEO"
          classNameParent="col-12 mb-3"
          value={row.p_seo_description}
          onChange={e => setRow({ ...row, p_seo_description: e.target.value })}
          required
          rows={3}
        />
        <Input
          text="Palabras clave SEO"
          placeholder="ticket, entradas"
          classNameParent="col-12 mb-3"
          value={row.p_seo_keywords}
          onChange={e => setRow({ ...row, p_seo_keywords: e.target.value })}
          required
        />
      </div>

      <div className="col-12 mt-3">
        <div className="d-flex align-items-center justify-content-between mb-2 flex-wrap gap-2">
          <div>
            <h5 className="mb-0">Media del evento</h5>
            <small className="text-muted">
              Sube imágenes optimizadas para mejorar carga y visualización.
            </small>
          </div>
        </div>

        <div className="row g-3">

          {/* 1) IMAGEN ZONAS */}
          <div className="col-12">
            <div className="card shadow-sm">
              <div className="card-body">
                <div className="row g-3 align-items-start">
                  <div className="col-12 col-lg-6">
                    <div className="d-flex justify-content-between align-items-start flex-wrap gap-2">
                      <div>
                        <h6 className="mb-1">1) Imagen de Zonas</h6>
                      </div>
                    </div>

                    <div className="mt-2">
                      <Input
                        type="file"
                        text="Seleccionar imagen"
                        classNameParent="mb-0"
                        required={rowId === ''}
                        invalid="El campo es obligatorio."
                        onChange={e => {
                          const files = e.target.files
                          setRow({ ...row, p_image_event: files })
                          setPreviewImage(files?.length ? URL.createObjectURL(files[0]) : null)
                        }}
                        accept="image/*"
                      />
                    </div>
                  </div>

                  <div className="col-12 col-lg-6">
                    <div className="border rounded p-2 bg-light">
                      <small className="text-muted d-block mb-2">Vista previa</small>

                      {(row.p_image_event_path || previewImage) ? (
                        <img
                          src={previewImage ? previewImage : apiResource({ url: row.p_image_event_path })}
                          alt={row.p_name_event}
                          className="img-fluid rounded"
                          style={{ maxHeight: 220, width: "100%", objectFit: "contain" }}
                        />
                      ) : (
                        <div
                          className="text-muted small d-flex align-items-center justify-content-center"
                          style={{ height: 220 }}
                        >
                          Sin imagen aún
                        </div>
                      )}
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          {/* 2) BANNER PEQUEÑO */}
          <div className="col-12">
            <div className="card shadow-sm">
              <div className="card-body">
                <div className="row g-3 align-items-start">
                  <div className="col-12 col-lg-6">
                    <h6 className="mb-1">2) Banner Pequeño</h6>
                    <small className="text-muted mr-2">
                      Ideal para listados / tarjetas. Recomendado: JPG.
                    </small>
                    <span className="badge bg-light text-dark border">667×375</span>

                    <div className="mt-2">
                      <Input
                        type="file"
                        text="Seleccionar banner pequeño"
                        classNameParent="mb-0"
                        required={rowId === ''}
                        invalid="El campo es obligatorio."
                        onChange={e => {
                          const files = e.target.files
                          setRow({ ...row, p_banner_small_event: files })
                          setPreviewBannerSmall(files?.length ? URL.createObjectURL(files[0]) : null)
                        }}
                        accept="image/*"
                      />
                    </div>
                  </div>

                  <div className="col-12 col-lg-6">
                    <div className="border rounded p-2 bg-light">
                      <small className="text-muted d-block mb-2">Vista previa</small>

                      {(row.p_banner_small_event_path || previewBannerSmall) ? (
                        <img
                          src={
                            previewBannerSmall
                              ? previewBannerSmall
                              : apiResource({ url: row.p_banner_small_event_path })
                          }
                          alt={row.p_name_event}
                          className="img-fluid rounded"
                          style={{ maxHeight: 220, width: "100%", objectFit: "cover" }}
                        />
                      ) : (
                        <div
                          className="text-muted small d-flex align-items-center justify-content-center"
                          style={{ height: 220 }}
                        >
                          Sin banner aún
                        </div>
                      )}
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          {/* 3) BANNER PRINCIPAL (RESPONSIVE) - 3 FILAS */}
          <div className="col-12">
            <div className="card shadow-sm border-primary">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-2">
                  <div>
                    <h6 className="mb-1">3) Banner Principal (Responsive)</h6>
                    <small className="text-muted">
                      Sube 3 versiones: Desktop / Tablet / Móvil.
                    </small>
                  </div>
                  <span className="badge bg-primary">Recomendado</span>
                </div>

                {/* Desktop */}
                <div className="row g-3 align-items-start mb-3">
                  <div className="col-12 col-lg-6">
                    <div className="d-flex justify-content-between align-items-center mb-1">
                      <strong className="small">Desktop</strong>
                      <span className="badge bg-light text-dark border">1920×580</span>
                    </div>
                    <Input
                      type="file"
                      text="Subir banner desktop"
                      classNameParent="mb-0"
                      required={rowId === ''}
                      invalid="El campo es obligatorio."
                      onChange={e => {
                        const files = e.target.files
                        setRow({ ...row, p_banner_large_event: files })
                        setPreviewBannerDesktop(files?.length ? URL.createObjectURL(files[0]) : null)
                      }}
                      accept="image/*"
                    />
                  </div>
                  <div className="col-12 col-lg-6">
                    <div className="border rounded p-2 bg-light">
                      <small className="text-muted d-block mb-2">Vista previa</small>
                      {(row.p_banner_large_event_path || previewBannerDesktop) ? (
                        <img
                          src={
                            previewBannerDesktop
                              ? previewBannerDesktop
                              : apiResource({ url: row.p_banner_large_event_path })
                          }
                          alt="Banner desktop"
                          className="img-fluid rounded"
                          style={{ maxHeight: 180, width: "100%", objectFit: "cover" }}
                        />
                      ) : (
                        <div
                          className="text-muted small d-flex align-items-center justify-content-center"
                          style={{ height: 180 }}
                        >
                          Sin banner desktop aún
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Tablet */}
                <div className="row g-3 align-items-start mb-3">
                  <div className="col-12 col-lg-6">
                    <div className="d-flex justify-content-between align-items-center mb-1">
                      <strong className="small">Tablet</strong>
                      <span className="badge bg-light text-dark border">1024×768</span>
                    </div>
                    <Input
                      type="file"
                      text="Subir banner tablet"
                      classNameParent="mb-0"
                      required={rowId === ''}
                      invalid="El campo es obligatorio."
                      onChange={e => {
                        const files = e.target.files
                        setRow({ ...row, p_banner_tablet_event: files })
                        setPreviewBannerTablet(files?.length ? URL.createObjectURL(files[0]) : null)
                      }}
                      accept="image/*"
                    />
                  </div>
                  <div className="col-12 col-lg-6">
                    <div className="border rounded p-2 bg-light">
                      <small className="text-muted d-block mb-2">Vista previa</small>
                      {(row.p_banner_tablet_event_path || previewBannerTablet) ? (
                        <img
                          src={
                            previewBannerTablet
                              ? previewBannerTablet
                              : apiResource({ url: row.p_banner_tablet_event_path })
                          }
                          alt="Banner tablet"
                          className="img-fluid rounded"
                          style={{ maxHeight: 180, width: "100%", objectFit: "cover" }}
                        />
                      ) : (
                        <div
                          className="text-muted small d-flex align-items-center justify-content-center"
                          style={{ height: 180 }}
                        >
                          Sin banner tablet aún
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Móvil */}
                <div className="row g-3 align-items-start">
                  <div className="col-12 col-lg-6">
                    <div className="d-flex justify-content-between align-items-center mb-1">
                      <strong className="small">Móvil</strong>
                      <span className="badge bg-light text-dark border">667×375</span>
                    </div>
                    <Input
                      type="file"
                      text="Subir banner móvil"
                      classNameParent="mb-0"
                      required={rowId === ''}
                      invalid="El campo es obligatorio."
                      onChange={e => {
                        const files = e.target.files
                        setRow({ ...row, p_banner_mobile_event: files })
                        setPreviewBannerMobile(files?.length ? URL.createObjectURL(files[0]) : null)
                      }}
                      accept="image/*"
                    />
                  </div>
                  <div className="col-12 col-lg-6">
                    <div className="border rounded p-2 bg-light">
                      <small className="text-muted d-block mb-2">Vista previa</small>
                      {(row.p_banner_mobile_event_path || previewBannerMobile) ? (
                        <img
                          src={
                            previewBannerMobile
                              ? previewBannerMobile
                              : apiResource({ url: row.p_banner_mobile_event_path })
                          }
                          alt="Banner móvil"
                          className="img-fluid rounded"
                          style={{ maxHeight: 180, width: "100%", objectFit: "cover" }}
                        />
                      ) : (
                        <div
                          className="text-muted small d-flex align-items-center justify-content-center"
                          style={{ height: 180 }}
                        >
                          Sin banner móvil aún
                        </div>
                      )}
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          {/* 4) FONDO BOLETO ECOMMERCE (IMAGEN) */}
          <div className="col-12">
            <div className="card shadow-sm">
              <div className="card-body">
                <div className="row g-3 align-items-start">
                  <div className="col-12 col-lg-6">
                    <h6 className="mb-1">4) Fondo Boleto Ecommerce</h6>
                    <small className="text-muted">
                      Imagen de fondo para el ticket (recomendado: PNG/JPG).
                    </small>
                    <span className="badge bg-light text-dark border">845x1600</span>

                    <div className="mt-2">
                      <Input
                        type="file"
                        text="Seleccionar fondo"
                        classNameParent="mb-0"
                        required={rowId === ''}
                        invalid="El campo es obligatorio."
                        onChange={e => {
                          const files = e.target.files
                          setRow({ ...row, p_pdf_background: files })
                          setPreviewBg(files?.length ? URL.createObjectURL(files[0]) : null)
                        }}
                        accept="image/*"
                      />
                    </div>
                  </div>

                  <div className="col-12 col-lg-6">
                    <div className="border rounded p-2 bg-light">
                      <small className="text-muted d-block mb-2">Vista previa</small>

                      {(row.p_pdf_background_path || previewBg) ? (
                        <img
                          src={previewBg ? previewBg : apiResource({ url: row.p_pdf_background_path })}
                          alt="Fondo boleto Ecommerce"
                          className="img-fluid rounded"
                          style={{ maxHeight: 220, width: "100%", objectFit: "contain" }}
                        />
                      ) : (
                        <div
                          className="text-muted small d-flex align-items-center justify-content-center"
                          style={{ height: 220 }}
                        >
                          Sin fondo aún
                        </div>
                      )}
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          {/* 5) FONDO BOLETO PUNTO DE VENTA (IMAGEN) */}
          <div className="col-12">
            <div className="card shadow-sm">
              <div className="card-body">
                <div className="row g-3 align-items-start">
                  <div className="col-12 col-lg-6">
                    <h6 className="mb-1">5) Fondo Boleto Punto de Venta</h6>
                    <small className="text-muted">
                      Imagen de fondo para boletos vendidos en punto de venta (PNG/JPG).
                    </small>
                    <span className="badge bg-light text-dark border">845x1600</span>

                    <div className="mt-2">
                      <Input
                        type="file"
                        text="Seleccionar fondo POS"
                        classNameParent="mb-0"
                        onChange={e => {
                          const files = e.target.files
                          setRow({ ...row, p_pdf_background_pos: files })
                          setPreviewBgPos(files?.length ? URL.createObjectURL(files[0]) : null)
                        }}
                        accept="image/*"
                      />
                    </div>
                  </div>

                  <div className="col-12 col-lg-6">
                    <div className="border rounded p-2 bg-light">
                      <small className="text-muted d-block mb-2">Vista previa</small>

                      {(row.p_pdf_background_pos_path || previewBgPos) ? (
                        <img
                          src={previewBgPos ? previewBgPos : apiResource({ url: row.p_pdf_background_pos_path })}
                          alt="Fondo boleto Punto de Venta"
                          className="img-fluid rounded"
                          style={{ maxHeight: 220, width: "100%", objectFit: "contain" }}
                        />
                      ) : (
                        <div
                          className="text-muted small d-flex align-items-center justify-content-center"
                          style={{ height: 220 }}
                        >
                          Sin fondo aún
                        </div>
                      )}
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </FormCustom>
  </ReactPlaceholder>
}

EventForm.defaultProps = {
  rowId: '',
  setReload: () => { },
}

export {
  EventForm
};